export default __webpack_public_path__ + "static/media/DocIcon.79e1d0ad.png";